import React, { FunctionComponent, KeyboardEvent } from 'react';
import { Dialog } from 'app/src/components/Wizard';
import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';

import styles from './InAppMigrationDialog.less';

const formatCreate = forNamespace(
  ['aa migration wizard', 'in app migration', 'create'],
  {
    shouldEscapeStrings: false,
  },
);

const formatLogIn = forNamespace(
  ['aa migration wizard', 'in app migration', 'login'],
  {
    shouldEscapeStrings: false,
  },
);

interface InAppMigrationDialogProps {
  closeDialog: () => void;
  image?: HTMLElement;
  mobileImage?: HTMLElement;
  migrationUrl: string;
  aaExists: boolean;
  onKeyPressCapture?: (e: KeyboardEvent) => void;
}

export const InAppMigrationDialog: FunctionComponent<InAppMigrationDialogProps> = ({
  closeDialog,
  image,
  mobileImage,
  migrationUrl,
  aaExists,
  onKeyPressCapture,
}) => {
  const f = aaExists ? formatLogIn : formatCreate;
  return (
    <Dialog
      title={f('title')}
      tip={
        <>
          {f('tip-text', {
            jiraLink: (
              <a
                href="https://www.atlassian.com/software/jira"
                key="jira-link"
                target="_blank"
              >
                Jira
              </a>
            ),
            confluenceLink: (
              <a
                href="https://www.atlassian.com/software/confluence"
                key="confluence-link"
                target="_blank"
              >
                Confluence
              </a>
            ),
          })}
        </>
      }
      closeDialog={closeDialog}
      isCentered={false}
      image={image}
      mobileImage={mobileImage}
      onKeyPressCapture={onKeyPressCapture}
    >
      <p>{f('main-message')}</p>
      <p>{f('secondary-message')}</p>

      <div className={styles.buttons}>
        <PrimaryButton onClick={() => (window.location.href = migrationUrl)}>
          {f('button-text')}
        </PrimaryButton>
      </div>
    </Dialog>
  );
};
